export default {"src":"/_next/static/media/phone-masking-hero.bfa2b7ce.svg","height":154,"width":300,"blurWidth":0,"blurHeight":0};